<template lang="html">
  <div class="logo">
    <div class="d-none d-sm-none d-md-none d-lg-block">
      <img class="ball" src="../assets/img/ball.png" alt="">
      <img class="axiox" src="../assets/img/logo/large.png" alt="">
    </div>
    <div class="d-sm-block d-md-block d-lg-none">
      <img class="fullsize-ball" src="../assets/img/ball.png" alt="">
      <img class="rotatedimg" src="../assets/img/logo/large.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
  @keyframes pulse {
      0% {
       transform: scale(1, 1);
      }

      50% {
       transform: scale(0.9, 0.9);
      }

      100% {
      transform: scale(1, 1);
      }
  }
  .rotatedimg {
    -webkit-transform:translate(-50%, -45%) rotate(-90deg);
    -moz-transform:translate(-50%, -45%) rotate(-90deg);
    -ms-transform:translate(-50%, -45%) rotate(-90deg);
    -o-transform:translate(-50%, -45%) rotate(-90deg);
    transform:translate(-50%, -45%) rotate(-90deg);
    width: 80vh !important;
    -o-object-fit: contain;
    object-fit: contain;
    z-index: 2;
    position: absolute;
    top: 50%;
    left: 50%;
  }
  .logo {
    position: relative;
    /* border: 1px solid white; */
    width: 100%;
    height: 100vh;
    /* overflow: hidden; */
  }
  .axiox {
    height: 100%;
    width: 100%;
    -o-object-fit: contain;
    object-fit: contain;
    z-index: 2;
    position: absolute;
    left: 0%;
  }
  .ball {
    position: absolute;
    height: 100%;
    width: 80%;
    left: 20%;
    -o-object-fit: contain;
    object-fit: contain;
    z-index: 2;
    webkit-animation: pulse 5s ease-in-out infinite;
    animation: pulse 5s ease-in-out infinite;
  }
  .fullsize-ball {
    position: absolute;
    height: 80%;
    width: 100%;
    left: 0%;
    top: 0;
    -o-object-fit: contain;
    object-fit: contain;
    z-index: 2;
    webkit-animation: pulse 5s ease-in-out infinite;
    animation: pulse 5s ease-in-out infinite;
  }
</style>
